// InviteHRModal.jsx
import React, { useState } from 'react';
import Modal from 'react-modal';
import { authApi, mentoringApi } from '../../axiosInstance'; // ← nutze die fertigen Instanzen

Modal.setAppElement('#root');

function InviteHRModal({ isOpen, onRequestClose }) {
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [packageOption, setPackageOption] = useState('Free-Paket');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  async function getCsrf() {
    try {
      const r = await authApi.get('/csrf-token', { withCredentials: true });
      return r?.data?.csrfToken || '';
    } catch {
      return '';
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError('');

    try {
      const csrf = await getCsrf();

      // WICHTIG: Superadmin-Route verwenden
      await mentoringApi.post(
        '/mentoring/invite/hr-user',
        {
          email,
          company,
          package: packageOption, // wird in invitations.package gespeichert
        },
        {
          withCredentials: true,
          headers: {
            'X-CSRF-Token': csrf,
            'X-Requested-With': 'XMLHttpRequest',
          },
        }
      );

      setSuccess(true);
      setEmail('');
      setCompany('');
      setPackageOption('Free-Paket');
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403) {
        setError('Kein Zugriff (nur für Superadmin / mentixx erlaubt).');
      } else {
        setError(err?.response?.data?.error || 'Fehler beim Versenden');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="HR-User einladen"
      className="bg-white p-6 rounded-xl max-w-lg mx-auto mt-20 shadow-xl relative"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start"
    >
      <h2 className="text-xl font-semibold mb-4">HR-User einladen</h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium">E-Mail-Adresse</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full p-2 border border-gray-300 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Firmenname</label>
          <input
            type="text"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            required
            className="w-full p-2 border border-gray-300 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium">Paket</label>
          <select
            value={packageOption}
            onChange={(e) => setPackageOption(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded"
          >
            <option>Free-Paket</option>
            <option>FirstMover-Paket</option>
            <option>Essentials-Paket</option>
            <option>Growth-Paket</option>
            <option>Enterprise-Paket</option>
          </select>
        </div>

        {error && <p className="text-red-600 text-sm">{error}</p>}
        {success && <p className="text-green-600 text-sm">Einladung erfolgreich versendet</p>}

        <div className="flex justify-end">
          <button
            type="submit"
            disabled={loading}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
          >
            {loading ? 'Senden...' : 'Einladung senden'}
          </button>
        </div>
      </form>

      <button
        onClick={onRequestClose}
        className="absolute top-2 right-4 text-gray-500 hover:text-gray-700"
      >
        ✕
      </button>
    </Modal>
  );
}

export default InviteHRModal;
